/**
 * @file: usePatchedAnimatedTextInputRef.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useEffect, useRef } from 'react';

export const usePatchedAnimatedTextInputRef = () => {
  const ref = useRef<any>(null);
  const setNativeProps = useRef<any>();

  useEffect(() => {
    if (ref.current == null || setNativeProps.current) return;

    ref.current.setNativeProps = (values: any) => {
      if ('style' in values && 'text' in values.style) {
        (ref.current as any).value = values.style.text;
      } else if (values && typeof values === 'object') {
        for (const p in values) {
          if (ref.current?.style) {
            ref.current.style[p] = values[p];
          }
        }
      }
    };
  }, []);

  return ref;
};
